import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

interface SEOProps {
  title: string;
  description: string;
  path: string;
  ogImage?: string;
  locale?: string;
  alternates?: Array<{ lang: string; href: string }>;
  jsonLd?: object;
}

export default function SEO({
  title,
  description,
  path,
  ogImage = "https://imagedelivery.net/zrm-9G6VghWX2PxlkBIQwA/3e46c252-afa9-4a67-e243-fa4a87f59100/w=1200,h=630,fit=cover,q=80,f=auto",
  locale = "de_DE",
  alternates = [],
  jsonLd,
}: SEOProps) {
  const { t } = useTranslation();
  const url = `https://leuchtende-hotelfotografie.com${path}`;
  const siteName = t("seo.siteName");

  return (
    <Helmet>
      <html lang={locale.split('_')[0]} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content="index,follow,max-image-preview:large" />
      
      {/* Hreflang tags */}
      {alternates.map((alt) => (
        <link key={alt.lang} rel="alternate" hrefLang={alt.lang} href={alt.href} />
      ))}
      
      {/* Open Graph tags */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content={locale} />
      
      {/* Twitter Card tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* JSON-LD structured data */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}